import { componentPalette } from "src/theme/component-palette";
import SuccessIcon from "../../assets/success.svg";
import { Modal as AntModal, Button, Row, Space } from "antd";

interface ModalProps {
  defaultTitle?: string;
  defaultMessage?: string;
  icon?: string;
  defaultCloseAfter?: number;
  defaultShowFooter?: boolean;
  defaultYesText?: string;
  defaultNoText?: string;
  defaultOnlyYes?: boolean;
}

interface ModalPromiseProps {
  title?: string;
  message?: string;
  showFooter?: boolean;
  closeAfter?: number;
  onAfterPopup?: () => void;
  onAfterClose?: () => void;
  onOk?: () => void;
  openFrom?: any;
  yesText?: string;
  noText?: string;
  onlyYes?: boolean;
  forceMaskClose?: boolean;
  width?: number;
  [key: string]: any;
}

const maskStyle = {
  backgroundColor: "rgba(255, 255, 255, 0.45)",
};

const CreateModal = (options: ModalProps) => (props: ModalPromiseProps) => {
  return new Promise<boolean>((resolve, reject) => {
    const {
      defaultTitle = "",
      defaultMessage = "",
      icon = SuccessIcon,
      defaultCloseAfter = 3000,
      defaultShowFooter = true,
      defaultYesText = "Yes",
      defaultNoText = "No",
      defaultOnlyYes = false,
    } = options;

    const {
      title = defaultTitle,
      message = defaultMessage,
      showFooter = defaultShowFooter,
      closeAfter = !props.showFooter && !defaultShowFooter ? 3000 : defaultCloseAfter,
      onAfterPopup = () => {},
      onAfterClose = () => {},
      openFrom = "default",
      yesText = defaultYesText,
      noText = defaultNoText,
      onlyYes = defaultOnlyYes,
      forceMaskClose,
      onOk: onPressOk,
      ...rest
    } = props;

    const onOk = () => {
      if (onPressOk) onPressOk();
      resolve(true);
      modal.destroy();
    };

    const onCancel = () => {
      resolve(false);
      modal.destroy();
    };

    let modal: any;

    const initModal = () => {
      return AntModal.info({
        content: (
          <div className="voc-modal success">
            <Row>
              <img className="modal-icon" src={icon} alt="warning" />
              {title && (
                <h3 data-testid="modal-title" className="modal-title">
                  {title}
                </h3>
              )}
            </Row>
            <p data-testid="modal-message" className="modal-message">
              {message}
            </p>
            {showFooter &&
              (onlyYes ? (
                <div className="modal-footer">
                  <Space>
                    <Button className="btn-primary" onClick={onOk}>
                      OK
                    </Button>
                  </Space>
                </div>
              ) : (
                <div>
                  <Space>
                    <Button
                      style={{ borderColor: componentPalette.primary, color: componentPalette.primary }}
                      ghost
                      type={"primary"}
                      onClick={onCancel}
                    >
                      {noText}
                    </Button>
                    <Button type={"primary"} onClick={onOk} style={{ background: componentPalette.error }}>
                      {yesText}
                    </Button>
                  </Space>
                </div>
              ))}
          </div>
        ),
        onCancel,
        width: props.width,
        maskClosable: forceMaskClose ? forceMaskClose : !showFooter,
        maskStyle: { ...maskStyle },
        wrapClassName: "voc-modal-wrapper",
        centered: true,
        icon: null,
        okButtonProps: { style: { display: "none" } },
        ...rest,
      });
    };

    if (openFrom === "default") {
      modal = initModal();
    } else {
      const el = document.createElement("div");
      el.onclick = () => {
        modal = initModal();
        document.body.removeChild(el);
      };
      document.body.appendChild(el);
      const clientRect = openFrom.getBoundingClientRect();
      const clientX = clientRect.left;
      const clientY = clientRect.top;

      const event = new MouseEvent("click", {
        clientX,
        clientY,
      });

      el.dispatchEvent(event);
    }

    setTimeout(() => {
      onAfterPopup();
    }, 100);

    if (closeAfter) {
      setTimeout(() => {
        resolve(false); // false means user didn't click on ok
        onAfterClose();
        modal.destroy();
      }, closeAfter);
    }

    // return control modal to control it from outside
    return modal;
  });
};

export default CreateModal;
